<template>
  <header ref="navbarRef" class="h-20 lg:h-25">
    <nav :class="[ 'w-full h-20 lg:h-25 p-4 lg:p-5 top-0 end-0 z-20 transition-transform duration-300 bg-primary-dark', true ? 'is-sticky fixed' : 'fixed lg:absolute' ]">
      <div v-if="ui.displayMobileSearch" class="w-full">
        <Search :label="$t('text-search-label')" variant="big" />
      </div>
      <div v-else class="flex justify-between items-center px-3 lg:px-10 h-full">
        <ShoppingBagBtn v-if="cart.totalUniqueItems > 0" class="mr-5 lg:hidden" />
        <LanguageSwitcherBtn v-else class="mr-5 lg:hidden" />
        <Logo class="mx-auto lg:mx-0" variant="color" />
        <MobileBurgerButton class="ml-5 lg:hidden" />
        <div class="hidden lg:block w-full">
          <div class="w-full pl-10 pr-5 overflow-hidden flex flex-row items-center justify-start">
            <Search :label="$t('text-search-label')" variant="big" />
          </div>
        </div>
        <ul class="hidden lg:flex items-center flex-shrink-0">
          <template v-for="{ routeCode, label, minWidth } in visibleLinks" :key="`${routeCode}_${label}`">
            <li v-if="routeCode !== ROUTES.CODE.AUCTIONS || configs.auctionFeature">
              <NavLink
                v-if="windowSize?.width?.value >= minWidth"
                :href="translatePath(routeCode)"
                :aria-label="$t(label)"
                active-class="text-selected-menu-hover"
                inactive-class="text-light"
                class="no-underline font-bold flex items-center transition-colors duration-200 hover:text-selected-menu-hover focus:text-selected-menu-hover mx-5"
              >
                <span @click="store.setLoadResetOthers">{{ $t(label) }}</span>
              </NavLink>
            </li>
          </template>
          <li class="px-5">
            <AddInspirationButton v-if="routeName.startsWith('inspiration___') || routeName.startsWith('inspiration-type-slug___')" />
            <StockAddHeaderButton v-else-if="routeName.startsWith('catalogue-slug___')" />
            <AddAdButton v-else />
          </li>
          <li class="pl-5">
            <FavoritesButton />
          </li>
          <li class="pl-5">
            <NotificationsButton />
          </li>
          <li class="pl-5">
            <HelpButton />
          </li>
          <li class="pl-5">
            <ShoppingBagBtn />
          </li>
          <li v-if="auth.isLoggedIn" class="pl-5">
            <AuthorizedMenu />
          </li>
          <li v-else class="pl-5">
            <JoinButton />
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script setup>
import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import { siteSettings } from "@settings/site.settings";
import { useAuthStore } from '@stores/auth';
import { useSelectedStore } from '@stores/selected';
import { useUIStore } from '@stores/ui';
import { useConfigStore } from '@stores/config';
import { useCartStore } from '@stores/cart';
import Logo from "@components/ui/logo";
import NavLink from "@components/ui/link/nav-link";
import AddAdButton from "@components/layout/navbar/add-ad-button";
import StockAddHeaderButton from "@components/stock/stock-add-header-button";
import AddInspirationButton from "@components/content/add-inspiration-button";
import AuthorizedMenu from "@components/layout/navbar/authorized-menu";
import JoinButton from "@components/layout/navbar/join-button";
import Search from "@components/common/search";
import ShoppingBagBtn from "@components/cart/shopping-bag-btn";
import FavoritesButton from "@components/layout/navbar/favorites-button";
import NotificationsButton from "@components/layout/navbar/notifications-button";
import HelpButton from "@components/layout/navbar/help-button";
import MobileBurgerButton from "@components/layout/navbar/mobile-burger-button";
import LanguageSwitcherBtn from "@components/common/language-switcher-btn";

const auth = useAuthStore();
const store = useSelectedStore();
const ui = useUIStore();
const configs = useConfigStore();
const cart = useCartStore();
const route = useRoute();
const windowSize = useWindowSize();

const props = defineProps({
    links: {
        type: Array,
        default: () => siteSettings.headerLinks
    }
})

const visibleLinks = computed(() => (props.links || []).filter(
    ({ routeCode }) => routeCode !== ROUTES.CODE.CATALOGUE || configs.catalogueFeature
));

const routeName = computed(() => route?.name || '');

</script>
